<ng-container *ngIf="findingRelatedProducts$(); else suggestions">
    <div class="page-content">
        <ngx-mare-skeleton [grid]="'2x3'"></ngx-mare-skeleton>
    </div>
</ng-container>
<ng-template #suggestions>
    <ng-container *ngIf="productSuggested$() && productSuggested$().length > 0; else noProducts">
        <ng-container [ngSwitch]="layout">
            <ng-container *ngSwitchCase="'carousel'">
                <ng-container *ngTemplateOutlet="carousel_template"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'promo-carousel'">
                <ng-container *ngTemplateOutlet="promo_carousel_template"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'grid'">
                <ng-container *ngTemplateOutlet="grid_template"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'list'">
                <ng-container *ngTemplateOutlet="list_template"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'cards'">
                <ng-container *ngTemplateOutlet="cards_template"></ng-container>
            </ng-container>

            <ng-container *ngSwitchCase="'suggestions'">
                <ng-container *ngTemplateOutlet="suggestions_template"></ng-container>
            </ng-container>
            
            <ng-container *ngSwitchDefault>
                <ng-container *ngTemplateOutlet="list_template"></ng-container>
            </ng-container>
        </ng-container>
    </ng-container>
</ng-template>

<ng-template #noProducts>
    <products-overview/>
</ng-template>



<ng-template #carousel_template>
    <angular-carousel class="related-carousel">
        <ng-container  *ngFor="let suggestedProduct of productSuggested$(); let i = index ">
            <div *angularCarouselSlide class="slide-related">
                <product-related-item [item]="suggestedProduct"></product-related-item>
            </div>
        </ng-container>
    </angular-carousel>
</ng-template>
<ng-template #promo_carousel_template>
    <angular-carousel class="related-carousel" [infinite]="false" [auto]="false" [duration]="5000"  isInViewport (isInViewport)="playCarousel = $event" [threshold]="0.2">
        <ng-container  *ngFor="let suggestedProduct of productSuggested$(); let i = index ">
            <div *angularCarouselSlide class="slide-related">
                <app-promo-product  [product]="suggestedProduct"></app-promo-product>
            </div>
        </ng-container>
    </angular-carousel>
</ng-template>
<ng-template #list_template >
    <ul class="list-unstyled">
        <li class="list-item" *ngFor="let suggestedProduct of productSuggested$(); let i = index ">
            <product-related-item [item]="suggestedProduct" [layout]="'list'" ></product-related-item>
        </li>
    </ul> 
</ng-template>

<ng-template #cards_template>
    <div class="list-cards container">
        <ng-container *ngFor="let suggestedProduct of productSuggested$(); let i = index ">
            <product-related-card [item]="suggestedProduct" ></product-related-card>
        </ng-container>
    </div>
</ng-template>
<ng-template #grid_template>
    <div class="grid grid-3cols gap-16">
        <div class="grid-item" *ngFor="let suggestedProduct of productSuggested$(); let i = index ">
            <product-related-item  [item]="suggestedProduct" [layout]="'card'"></product-related-item>
        </div>
    </div>
</ng-template>


<ng-template #suggestions_template>
    <!-- <ng-container *ngIf="productSuggested$() "> -->
    <div class="page-content" isInViewport (isInViewport)="reveal($event)">
        <app-section-title  [titletag]="'page.related.topic_offer' | translate" [sectionclass]="'text-center mb--64'">
            
                <ngx-typed-writer *ngIf="isInView" 
                [strings]="['<h2>La AI di Delfi ha formulato una proposta personalizzata<br/>per i seguenti punti di debolezza</h2>']"
                [isHTML]="true" 
                [startDelay]="250" 
                [cursorChar]="'|'" 
                [showCursor]="false" 
                [typeSpeed]="10" 
                [backSpeed]="10"
                [loop]="false" 
                (completeLoop)="setSuggestions()"> </ngx-typed-writer>
            
            <!-- <div class="row gap-12">
                <div class="col col-lg-8 col-lg-offset-2">{{ 'page.related.subtitle_offer' | translate }}</div>
            </div> -->
        </app-section-title>
      
        <ng-container *ngIf="show_suggestions && productSuggested$().length > 0">
            <ng-container *ngFor="let group of productSuggested$(); let i = index ">
                <product-related-suggestion [idx]="i" *ngIf="currentIndex >= i" [suggestion]="group" (completed)="showNext($event)"></product-related-suggestion>
            </ng-container>
            <loader-report  [@slideInUp]="currentIndex == productSuggested$().length ? 'leave':'enter'"  *ngIf="currentIndex < productSuggested$().length"[position]="'bottom'"></loader-report>
            
            <!-- <cdk-virtual-scroll-viewport appendOnly itemSize="1" class="example-viewport">
                <div *cdkVirtualFor="let group of productSuggested$(); let i = index" class="example-item">
                    <product-related-suggestion [suggestion]="group"></product-related-suggestion>
                </div>
              </cdk-virtual-scroll-viewport> -->


        </ng-container>
    </div>
    <!-- </ng-container> -->
</ng-template>
